import { render, staticRenderFns } from "./ShortDescriptionPlanInfo.vue?vue&type=template&id=267b55ff&scoped=true"
import script from "./ShortDescriptionPlanInfo.vue?vue&type=script&lang=js"
export * from "./ShortDescriptionPlanInfo.vue?vue&type=script&lang=js"
import style0 from "./ShortDescriptionPlanInfo.vue?vue&type=style&index=0&id=267b55ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b55ff",
  null
  
)

export default component.exports